<section class="toast__title mat-body-small">
	@if(process().status === "running"){
		<span>{{"Vorgang gestartet" | translate : "headline-process-started"}}</span>
	}
	@else if(process().status === "readyToDownload"){
		<span>{{"Bereit zum Download" | translate : "headline-download-ready"}}</span>
	}
</section>
<section class="process__details">
	<strong class="mat-label-large">
			{{process().type}} · {{process().name}} · {{process().contextName}}
	</strong>
</section>

@if (process().status === "readyToDownload") {
	@if(process().createdAt){
		 <app-date-time [date]="process().createdAt!"/>
	}
	<button mat-stroked-button (click)="onDownloadClick($event)">
		<ogs-m3-icon icon="download" matButtonIcon/>
		{{"Download" | translate : "label-download"}}
	</button>
}